export function getCurrency(value: string | number | null | undefined) {
    if (value === null || value === undefined || value === '') {
        return 'R$ 0,00';
    }
    const valueString = typeof value === 'number' ? value.toString() : value;
    let valueSplit = valueString.toString().split(/[,.]+/);
    let cents = valueSplit[valueSplit.length - 1];
    if (valueSplit.length === 1 || cents.length > 2) {
        cents = '00';
        return 'R$ ' + setDecimals(valueSplit.join(), cents);
    } else {
        cents = cents.length === 2 ? cents : `${cents}0`;
        valueSplit.pop();
        return 'R$ ' + setDecimals(valueSplit.join(''), cents);
    }
}

export function setDecimals(int: string, cents: string) {
    if (int.length > 3) {
        let newValue = int.slice(0, -3) + '.' + int.slice(-3);
        return newValue + ',' + cents;
    }
    return int + ',' + cents;
}